import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BannerService } from '@appNeo/core/services/banner/banner.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { PaquetesService } from '../paquetes/paquetes.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CumpleanosFrontService {

  constructor(
    private edicionSeccionesService: EdicionSeccionesService,
    private bannerService: BannerService,
    private auxiliarService: AuxiliarService,
    private paquetesService: PaquetesService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    let peticion = {
      banner: this.bannerService.get().pipe(
        map(resp => {
          return resp = {
            ...resp, 
            ...this.auxiliarService.obtenerContenidoPorIdioma(resp?.idiomas)
          } 
        }),
        catchError(err => of(err))
      ),
      paquetes: this.paquetesService.getAll(undefined, undefined, { activo: 1, idIdioma: environment.idioma_defecto, order: 'id', tipoOrden: 'asc' }),
      precargaMeta: this.edicionSeccionesService.getContenidoBloquesSubseccion('cumpleanos-meta').pipe(
        catchError(err => of(err))
      ),
      precargaTitulo: this.edicionSeccionesService.getContenidoBloquesSubseccion('cumpleanos-txt').pipe(
        catchError(err => of(err))
      )
    };

    return forkJoin(peticion);
  }
}
